import { store } from '../redux/store';
import { Form, SubmitFormBody } from '../models/forms.model';
import httpService from './httpService';
import { setForms, setCurrentForm, updateFormResponse } from '../redux/slices/formsSlice';

export const formsService = {
  getAllFormsForCommunity: async (communityId: number): Promise<Form[]> => {
    const { data } = await httpService.get<Form[]>(`/networks/communities/${communityId}/forms`);
    store.dispatch(setForms({ communityId, forms: data }));
    return data;
  },

  getFormBySlug: async (communityId: number, formSlug: string): Promise<Form> => {
    const { data } = await httpService.get<Form>(`/networks/communities/${communityId}/forms/${formSlug}`);
    store.dispatch(setCurrentForm(data));
    return data;
  },

  createForm: async (communityId: number, body: any): Promise<Form> => {
    const { data } = await httpService.post<Form>(`/networks/communities/${communityId}/forms`, body);
    return data;
  },

  updateForm: async (communityId: number, formId: string, body: any): Promise<Form> => {
    const { data } = await httpService.put<Form>(`/networks/communities/${communityId}/forms/${formId}`, body);
    return data;
  },

  deleteForm: async (communityId: number, formId: string): Promise<void> => {
    await httpService.delete(`/networks/communities/${communityId}/forms/${formId}`);
  },

  submitFormResponse: async (communityId: number, formSlug: string, body: SubmitFormBody): Promise<any> => {
    const { data } = await httpService.post(`/networks/communities/${communityId}/forms/${formSlug}/responses`, body);
    // Update the current form with the new response
    store.dispatch(updateFormResponse({ formSlug, response: data }));
    return data;
  },

  updateFormResponse: async (communityId: number, formSlug: string, body: SubmitFormBody): Promise<any> => {
    const { data } = await httpService.put(`/networks/communities/${communityId}/forms/${formSlug}/responses`, body);
    // Update the current form with the updated response
    store.dispatch(updateFormResponse({ formSlug, response: data }));
    return data;
  },

  getFormResponses: async (communityId: number, formSlug: string): Promise<any[]> => {
    const { data } = await httpService.get(`/networks/communities/${communityId}/forms/${formSlug}/responses`);
    return data;
  },
};
